import { Component, OnDestroy, OnInit, ViewEncapsulation, ViewChild, TemplateRef } from '@angular/core';
import { BehaviorSubject, Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import * as _ from 'lodash';
import { FuseConfigService } from '@fuse/services/config.service';
import { FuseSidebarService } from '@fuse/components/sidebar/sidebar.service';
import { navigation } from 'app/navigation/navigation';
import { Router, NavigationEnd } from '@angular/router';
import { ParseService } from 'app/shared/common/parse/parse.service';
import { MatDialog } from '@angular/material/dialog';
import { ProfileService } from 'app/main/pages/profile/profile.service';
import { QueryInterface } from 'app/shared/common/parse/query-interface';
import { StorageConfiguration } from 'app/shared/common/storage-setting/storage-configuration';
import { HardCodedValues } from 'app/shared/common/hard-coded-values';
import { SocketService } from 'app/shared/common/helper/socket.service';
import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import { DateServiceService } from 'app/shared/common/helper/dateservice';
import { TodoListItemService } from 'app/main/pages/todo-list/todo-list-item/todo-list-item.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { GetterSetter } from 'app/shared/common/helper/project';
import { environment } from 'environments/environment';
import { ToolbarService } from './toolbar.service';

@Component({
    selector: 'toolbar',
    templateUrl: './toolbar.component.html',
    styleUrls: ['./toolbar.component.scss'],
    encapsulation: ViewEncapsulation.None
})

export class ToolbarComponent implements OnInit, OnDestroy {

    horizontalNavbar: boolean;
    rightNavbar: boolean;
    hiddenNavbar: boolean;
    languages: any;
    navigation: any;
    selectedLanguage: any;
    userStatusOptions: any[];
    firstname: String;
    lastname: String;
    proImage: any;
    objectId: any;
    profileValue: any;
    profId: any;
    imageURL: string = "assets/images/avatars/profile.jpg";
    support: any;

    // Private
    private _unsubscribeAll: Subject<any>;
    empRole: any;
    empUserId: any;
    sessionToken: string;
    supportLink: string;
    @ViewChild("logutPop", { static: false }) logutPop: TemplateRef<any>;
    @ViewChild("clientPop", { static: false }) clientPop: TemplateRef<any>;
    @ViewChild("restart", { static: false }) restart: TemplateRef<any>;

    profileId = this.parseService.instance.User.current() ? this.parseService.instance.User.current().get('profile').id : '';
    notificationCount = 0;
    notificationList = [];
    pageNumber = 1;
    dialogRef: any;
    notificationResult = [];
    isSidebar = false;
    notificationListRead = 0;
    readNotifications = [];
    readNotificationsList = new BehaviorSubject([]);
    notificationListUnRead = 0;
    unReadNotifications = [];
    unReadNotificationsList = new BehaviorSubject([]);
    @ViewChild(CdkVirtualScrollViewport, { static: false })
    viewPort: CdkVirtualScrollViewport
    desktopCurrentStatus: { message: string; status: string; };
    tenantId: any;
    today: any;
    trailExpiryDate: any;
    extendedExpiringDate: any;
    isTrailExpiry: boolean;
    currentlyWorkingTask: any;
    activeStatus: string;
    currentRoute: any;
    statusForm: FormGroup;
    statusHeight: string;
    projectInfo = [];
    email: string;
    userImage: any;
    viewProjectName: any;
    inTime: any;
    workStatusShow: boolean;
    totalBreakHours: number = 0;
    projectListView: boolean;
    isWebDesktop: boolean;
    workHoursClosed: boolean;
    subscription: Subscription
    isLogin: boolean;
    loggedTime: any;
    inTimeNotChanged: boolean;
    userTimeSheetRecord = [];
    taskWorkingHours: number;
    timeClear: NodeJS.Timeout;
    isTaskInprogress: boolean;
    isLogOut: boolean;
    restartTime: string;
    currentTaskProject: any;
    statusButton: string;
    selectedProject: any;
    /**
     * Constructor
     *
     * @param {FuseConfigService} _fuseConfigService
     * @param {FuseSidebarService} _fuseSidebarService
     * @param {TranslateService} _translateService
     */
    constructor(private router: Router,
        private parseService: ParseService,
        private _fuseConfigService: FuseConfigService,
        private _fuseSidebarService: FuseSidebarService,
        public dialog: MatDialog,
        private _translateService: TranslateService,
        private profileService: ProfileService,
        private queryInterface: QueryInterface,
        private storageConfiguration: StorageConfiguration,
        private hardCodedValues: HardCodedValues,
        private _socket: SocketService,
        private dateService: DateServiceService,
        private todoListItemService: TodoListItemService,
        public fb: FormBuilder,
        private toastr: ToastrService,
        private projectService: GetterSetter,
        private toolbarService: ToolbarService
    ) {

        /**
         * * Show the task name and time in the header when task is stared or resumed
         */
        this.todoListItemService.selectedTaskForHeader.subscribe((data) => {
            // this.selectProject();
            if (data === '') { return; } // return if empty string
            if (data !== false) { // If stated a task|
                localStorage.setItem('currentlyWorkingTask', JSON.stringify(data));
                this.currentlyWorkingTask = JSON.parse(localStorage.getItem('currentlyWorkingTask'));
                // const projectId = this.currentlyWorkingTask.Project ? this.currentlyWorkingTask.Project.objectId :
                //  this.storageConfiguration.sessionGetItem(this.storageConfiguration.projectId);
                // if (projectId != this.storageConfiguration.sessionGetItem(this.storageConfiguration.projectId)) {
                // this.onProjectChange(projectId);
                // }
                const taskStartTime = +localStorage.getItem('taskStartTime');
                if (taskStartTime !== undefined) {
                    this.isTaskInprogress = true;
                    // this.currentTaskProject = projectId;
                    const currentTime = Date.now();
                    const differenceTime = (currentTime - taskStartTime) / 1000;
                    this.taskWorkingHours = Math.floor(differenceTime);
                    clearInterval(this.timeClear);
                    this.timeClear = setInterval(() => {
                        this.taskWorkingHours += 1;
                        this.todoListItemService.getInprogressTaskTime(this.taskWorkingHours);
                    }, 1000);
                }
            } else if (data === false) { // saving the running task
                this.isTaskInprogress = false;
                localStorage.removeItem('currentlyWorkingTask');
                clearInterval(this.timeClear);
                this.currentlyWorkingTask = {};
                this.taskWorkingHours = 0;
            }
        });

        /**
         * * resume the task current time if the page get refreshed
         */
        if (localStorage.getItem('taskStartTime')) {
            this.currentlyWorkingTask = JSON.parse(localStorage.getItem('currentlyWorkingTask'));
            // console.log('currentlyWorkingTask', this.currentlyWorkingTask);
            this.isTaskInprogress = true;
            const taskStartTime = +localStorage.getItem('taskStartTime');
            const currentTime = Date.now();
            const differenceTime = (currentTime - taskStartTime) / 1000;
            this.taskWorkingHours = Math.floor(differenceTime);
            clearInterval(this.timeClear);
            this.timeClear = setInterval(() => {
                this.taskWorkingHours += 1;
                this.todoListItemService.getInprogressTaskTime(this.taskWorkingHours);
            }, 1000);
        }

        this.subscription = this.projectService.onMessage().subscribe(message => {
            if (message) {
                this.inTimeNotChanged = true;
                // this.selectProject();
                // this.userLogged();
            }
        });
        // this.userLogged();
        this.getUserInTime();
        this.tenantId = this.storageConfiguration.sessionGetItem(this.storageConfiguration.tenantId);
        var currentUser = this.parseService.instance.User.current() ? this.parseService.instance.User.current() : '';
        if (currentUser) {
            this.firstname = currentUser.get('firstName');
            this.lastname = currentUser.get('lastName');
            this.objectId = currentUser.id;
            this.email = currentUser.get('email');
        }
        this._socket.getNotificationData().subscribe((data => {
            this.getUnReadNotifications();
        }));

        // Set the defaults
        this.userStatusOptions = [
            {
                'title': 'Online',
                'icon': 'icon-checkbox-marked-circle',
                'color': '#4CAF50'
            },
            {
                'title': 'Away',
                'icon': 'icon-clock',
                'color': '#FFC107'
            },
            {
                'title': 'Do not Disturb',
                'icon': 'icon-minus-circle',
                'color': '#F44336'
            },
            {
                'title': 'Invisible',
                'icon': 'icon-checkbox-blank-circle-outline',
                'color': '#BDBDBD'
            },
            {
                'title': 'Offline',
                'icon': 'icon-checkbox-blank-circle-outline',
                'color': '#616161'
            }
        ];

        this.languages = [
            {
                id: 'en',
                title: 'English',
                flag: 'us'
            },
            {
                id: 'tr',
                title: 'Turkish',
                flag: 'tr'
            }
        ];

        this.navigation = navigation;

        // Set the private defaults
        this._unsubscribeAll = new Subject();
        this.profileService.photosProfile.subscribe(result => {
            if (result) {
                this.getProfilePhotos();
            }
        });
        this.getDesktopStatus();
        // this.getCurrentUser();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void {
        this.currentlyWorkingTask = JSON.parse(localStorage.getItem('currentlyWorkingTask'));
        /**
         * * Get the latest desktop status for a user from socket and
         * * update the value in the header toolbar
         */
        this._socket.updateMyStatus.subscribe((event: any) => {
            this.getDesktopStatus((cb) => {
                if (cb.canShowNotification === true) {
                    // this._socket.socketNotification('You are ' + cb.message + ' in the desktop application');
                    this._socket.socketNotification(event.message);
                } else {
                    // this._socket.socketNotification('notification');
                }
            });
        });
        this.empRole = this.storageConfiguration.sessionGetItem(this.storageConfiguration.role);
        this.empUserId = this.parseService.instance.User.current() ? this.parseService.instance.User.current().id : '';
        this.sessionToken = this.storageConfiguration.sessionGetItem(this.storageConfiguration.sessiontoken);
        this.supportLink = "https://support.whatsdare.com/auth/became?token=" + this.sessionToken;

        if (this.objectId) {
            this.getProfilePhotos();
        }
        // Subscribe to the config changes
        this._fuseConfigService.config
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((settings) => {
                this.horizontalNavbar = settings.layout.navbar.position === 'top';
                this.rightNavbar = settings.layout.navbar.position === 'right';
                this.hiddenNavbar = settings.layout.navbar.hidden === true;
            });

        // Set the selected language from default languages
        this.selectedLanguage = _.find(this.languages, { 'id': this._translateService.currentLang });
        let isloggedIn = this.storageConfiguration.sessionGetItem(this.storageConfiguration.isloggedIn);
        console.log('isloggedIn####', isloggedIn)

        if (isloggedIn) {
            console.log('isloggedIn', isloggedIn)
            this.getCustomerDetails();
            this.getReadNotifications();
            this.getUnReadNotifications();
        }
        this.workStatusFrom();

        // (async () => {
        //     await this.selectProject();

        //     this.selectedProject = this.projectInfo.find( pro => pro.projectName === 'Unassigned Project');
        // })();
    }

    workStatusFrom() {
        this.statusForm = this.fb.group({
            meetingSubject: ['', Validators.required],
            with: ['', Validators.required],
            startTime: ['', Validators.required],
            endTime: ['', Validators.required],
            reason: ['', Validators.required],
            projectId: ['', Validators.required],
            inTime: ['', Validators.required],
            others: ['', Validators.required]
        });
    }

    async getCustomerDetails(): Promise<void> {
        const Customer = this.parseService.instance.Object.extend('Customer');
        const customerQuery = new this.parseService.instance.Query(Customer);
        customerQuery.equalTo('tenantId', this.tenantId);
        await customerQuery.find().then((customer) => {
            const customerData = customer[0];
            this.today = new Date().setHours(0, 0, 0, 0);
            // this.today = 1645468200000;
            this.trailExpiryDate = customerData.get('trailExpiryDate').setHours(0, 0, 0, 0);
            if (this.today < this.trailExpiryDate) {
                this.isTrailExpiry = false;
            } else {
                this.isTrailExpiry = true;
            }
            this.extendedExpiringDate = customerData.get('extendedExpiringDate');
            // console.log('today', this.today);
            // console.log('trailExpiryDate', this.trailExpiryDate);
        });
    }

    /**
     * On destroy
     */
    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Toggle sidebar open
     *
     * @param key
     */
    toggleSidebarOpen(key): void {
        this._fuseSidebarService.getSidebar(key).toggleOpen();
    }

    /**
     * Search
     *
     * @param value
     */
    search(value): void {
        // Do your search here...
    }

    /**
     * Set the language
     *
     * @param lang
     */
    setLanguage(lang): void {
        // Set the selected language for the toolbar
        this.selectedLanguage = lang;

        // Use the selected language for translations
        this._translateService.use(lang.id);
    }
    profile() {
        this.router.navigate(['profile']);
    }

    resetpassword() {
        if (this.router.url === "reset-password") {
            location.reload();
        } else {
            this.router.navigate(['reset-password']);
        }
    }
    downloadApps(): void {
        this.router.navigate(['desktop-apps-download']);
    }

    async logutPopup() {
        let isloggedIn = this.storageConfiguration.sessionGetItem(this.storageConfiguration.isloggedIn);
        console.log('isloggedIn####', isloggedIn)

        if (isloggedIn) {
            let queryInstances = this.parseService.instance.Object.extend('UserTimeSheet');
            let userTimeSheet = new this.parseService.instance.Query(queryInstances);
            userTimeSheet.equalTo('profileId', { __type: 'Pointer', className: 'Profile', objectId: this.profileId });
            const today = new Date();
            const currentDate = this.dateService.startEndDateByDate(today);
            userTimeSheet.greaterThan('createdAt', currentDate[0]);
            userTimeSheet.lessThan('createdAt', currentDate[1]);
            let user = await userTimeSheet.find();
            let userStatus = '';
            if (user.length > 0) {
                userStatus = user[0].get('currentStatus');
            }
            const isWebDesktop = this.parseService.instance.User.current().get('profile').get('isWebDesktop');
            if (userStatus == 'work' && isWebDesktop || userStatus == 'idle' && isWebDesktop) {
                return this.toastr.warning('Please close the TimeSheet!!');
            }
            else {
                this.dialog.open(this.logutPop, {
                    width: "300px"
                });
            }
        }
    }

    close() {
        this.dialog.closeAll();
    }

    logout() {
        this.toastr.success('Logout successfully');
        setTimeout(() => {
            if (localStorage.getItem('loginType') == 'Marketing') {
                this.parseService.instance.User.logOut();
                localStorage.clear();
                sessionStorage.clear();
                window.location.href = `${environment.marketingSite}`;
            }
            else {
                this.parseService.instance.User.logOut();
                localStorage.clear();
                sessionStorage.clear();
                location.reload();
            }
        }, 1000);
    }

    async getProfilePhotos() {
        await this.queryInterface.executeQuery(this.parseService, "User", [{ condition: "equalTo", field: "objectId", value: this.objectId },
        { condition: "include", value: "profile" }]).then(result => {
            if (result.length > 0) {
                var results = result[0];
                let jsonText = JSON.stringify(results);
                let userProfile = JSON.parse(jsonText);
                this.profileValue = userProfile;
                this.profId = this.profileValue.profile.profileImageInfo.imageId;
                this.proImage = this.profileValue.profile.profileImageInfo.url;
            }
        });
    }

    async getReadNotifications() {
        let nextNotifications = [];
        let queryInstance = this.parseService.instance.Object.extend('Notifications');
        let query = new this.parseService.instance.Query(queryInstance);
        query.include('receiverId');
        query.equalTo('receiverId', { __type: 'Pointer', className: 'Profile', objectId: this.profileId });
        query.equalTo('isRead', true);
        query.include('ownerId');
        query.descending('updatedAt');
        query.withCount();
        query.limit(10);
        query.skip(this.readNotifications.length);
        let results = await query.find();
        let notifications = results.results;
        for (const element of notifications) {
            let profile = '';
            var myObj = element.get('ownerId').get('profileImageInfo');
            if (this.isEmpty(myObj)) {
                profile = this.hardCodedValues.defaultProfileImg;
            } else {
                profile = element.get('ownerId').get('profileImageInfo').url
            }
            let alreadyExistIndex = this.readNotifications.findIndex(x => x.id == element.id);
            if (alreadyExistIndex == -1) {
                nextNotifications.push({
                    id: element.id,
                    name: element.get('ownerId').get('firstName') + ' ' + element.get('ownerId').get('lastName'),
                    profile: profile,
                    message: element.get('message'),
                    date: element.get('createdAt'),
                    isRead: element.get('isRead')
                });
            }
        }
        this.readNotifications = [...this.readNotifications, ...nextNotifications];
        this.readNotificationsList = new BehaviorSubject(this.readNotifications);
        this.notificationListRead = this.readNotifications.length;
    }

    async getUnReadNotifications() {
        let nextNotifications = [];
        let queryInstance = this.parseService.instance.Object.extend('Notifications');
        let query = new this.parseService.instance.Query(queryInstance);
        query.include('receiverId');
        query.equalTo('receiverId', { __type: 'Pointer', className: 'Profile', objectId: this.profileId });
        query.equalTo('isRead', false);
        query.include('ownerId');
        query.descending('createdAt');
        query.withCount();
        query.limit(10);
        query.skip(this.unReadNotifications.length);
        let results = await query.find();
        this.notificationCount = results.count;
        let notifications = results.results;
        for (const element of notifications) {
            let profile = '';
            var myObj = element.get('ownerId').get('profileImageInfo');
            if (this.isEmpty(myObj)) {
                profile = this.hardCodedValues.defaultProfileImg;
            } else {
                profile = element.get('ownerId').get('profileImageInfo').url
            }
            let alreadyExistIndex = this.unReadNotifications.findIndex(x => x.id == element.id);
            if (alreadyExistIndex == -1) {
                this.notificationResult.push(element);
                nextNotifications.push({
                    id: element.id,
                    name: element.get('ownerId').get('firstName') + ' ' + element.get('ownerId').get('lastName'),
                    profile: profile,
                    message: element.get('message'),
                    date: element.get('createdAt'),
                    isRead: element.get('isRead')
                });
            }
        }
        if (!this.isSidebar) {
            await this.getReadNotifications();
        }
        this.unReadNotifications = [...this.unReadNotifications, ...nextNotifications];
        this.unReadNotificationsList = new BehaviorSubject(this.unReadNotifications);
        this.notificationListUnRead = this.unReadNotifications.length;
    }

    isEmpty(obj) {
        for (var key in obj) {
            if (obj.hasOwnProperty(key))
                return false;
        }
        return true;
    }

    async updateNotifications(results) {
        for (const element of results) {
            element.set('isRead', true);
            element.set('readSource', 'web');
            await element.save();
        }
    }

    async showSidebar() {
        this.isSidebar = !this.isSidebar;
        if (this.isSidebar == false && this.notificationResult.length > 0) {
            await this.updateNotifications(this.notificationResult);
            this.unReadNotifications = [];
            await this.getUnReadNotifications();
        }
    }
    async getDesktopStatus(cb?): Promise<void> {
        const startEndDateByDate = this.dateService.startEndDateByDate(new Date());
        let isloggedIn = this.storageConfiguration.sessionGetItem(this.storageConfiguration.isloggedIn);
        console.log('isloggedIn####', isloggedIn)

        if (isloggedIn) {
            const UserTimeSheet = this.parseService.instance.Object.extend('UserTimeSheet');
            const userTimeSheetQuery = new this.parseService.instance.Query(UserTimeSheet);
            userTimeSheetQuery.greaterThan('createdAt', startEndDateByDate[0]);
            userTimeSheetQuery.lessThan('createdAt', startEndDateByDate[1]);
            userTimeSheetQuery.equalTo('profileId', { __type: 'Pointer', className: 'Profile', objectId: this.profileId });
            userTimeSheetQuery.find().then((userTimeSheet) => {
                const userTimeSheetData = userTimeSheet.length > 0 ? userTimeSheet[0].get('currentStatus') : undefined;
                const message = !userTimeSheetData ? 'Not yet Login' : userTimeSheetData === 'work' ? 'Online' : userTimeSheetData === 'Idle' ? 'idle' : 'Offline';
                const status = !userTimeSheetData ? 'NTL' : userTimeSheetData === 'work' ? 'Online' : userTimeSheetData === 'idle' ? 'idle' : 'offline';
                let canShowNotification;
                if (this.desktopCurrentStatus !== undefined) {
                    canShowNotification = this.desktopCurrentStatus.message === message ? false : true;
                } else {
                    canShowNotification = false;
                }
                this.desktopCurrentStatus = {
                    message: message,
                    status: status
                };
                if (cb) {
                    cb({ canShowNotification, message });
                }
            });
        }
    }

    //Subscription plan page routing
    manageSubscription() {
        this.router.navigate(['plans']);
    }



    convertUtcToLocalTime(time) {
        var d = new Date(time);
        let userStartHours = d.getHours();
        let userEndHours = d.getMinutes();
        return [userStartHours, userEndHours]
    }


    async getUserInTime() {
        let isloggedIn = this.storageConfiguration.sessionGetItem(this.storageConfiguration.isloggedIn);
        console.log('isloggedIn####', isloggedIn)

        if (isloggedIn) {
            let Profile = this.parseService.instance.Object.extend('Profile');
            let profile = new this.parseService.instance.Query(Profile);
            profile.equalTo('objectId', this.profileId)
            let profileDetails = await profile.find();
            this.inTime = profileDetails[0].get('officialInfo').startTime;
            this.isWebDesktop = profileDetails[0].get('isWebDesktop');
        }
    }

    handleMissingImage(event) {
        this.proImage = this.imageURL;
    }
}


